/**
 * Enums autoritativos de la plataforma.
 * Referencia: PIPELINE.md secciones 4, 5, 8.
 */

export const ROLES = ['cliente_elawan', 'tecnico_aosenuma', 'admin', 'auditor'] as const;
export type Rol = (typeof ROLES)[number];

/**
 * Estados del semaforo de gestion (5 fases del ciclo).
 * Definicion canonica unica: lo que aqui se exporta debe coincidir con
 * `EstadoSemaforo` declarado en `inventario.ts`. Los colores viven en
 * `tokens.css` como `--st-*` (no se hardcodean aqui).
 *
 * Ciclo:
 *   sin_prospectar -> en_valoracion -> en_negociacion -> contratada
 *                                                    \-> inviable
 */
export const ESTADOS_GESTION = [
  'sin_prospectar',
  'en_valoracion',
  'en_negociacion',
  'contratada',
  'inviable',
] as const;
export type EstadoGestion = (typeof ESTADOS_GESTION)[number];

export const ANILLOS = ['R0', 'R1', 'R2', 'R3', 'R4_out'] as const;
export type Anillo = (typeof ANILLOS)[number];

export const TIPOS_PROPIEDAD = ['EJIDO', 'PROP_FED', 'PROP_PRIV', 'USO_COM'] as const;
export type TipoPropiedad = (typeof TIPOS_PROPIEDAD)[number];

/**
 * Clase de unidad territorial en `parcelas.tipo_parcela` (mig 0068).
 * Mismo vocabulario que `inventario_titulares.tipo_parcela` (mig 0003)
 * + 'PRIVADA' para los proxies de predios privados (source='cliente').
 */
export const TIPOS_PARCELA = [
  'PARCELA_INDIVIDUAL',
  'USO_COMUN',
  'ASENTAMIENTO',
  'VACANTE_NUCLEO_AGRARIO',
  'PRIVADA',
] as const;
export type TipoParcela = (typeof TIPOS_PARCELA)[number];

/**
 * 10 docs ejido + 9 docs propiedad privada (PIPELINE.md secc. 4.4).
 * Saul confirma con Tomas/Merced antes del dia 3.
 */
export const TIPOS_DOC_EJIDO = [
  'acta_constitutiva_ejido',
  'plano_interno_aprobado',
  'acta_asamblea_delegacion',
  'constancia_vigencia_comisariado',
  'lista_nominal_ejidatarios',
  'certificado_parcelario',
  'identificacion_oficial',
  'curp',
  'comprobante_domicilio',
  'rfc_homoclave',
] as const;

export const TIPOS_DOC_PRIVADO = [
  'escritura_publica',
  'certificado_libertad_gravamen',
  'no_adeudo_predial',
  'no_adeudo_agua',
  'identificacion_oficial',
  'curp',
  'comprobante_domicilio',
  'rfc_homoclave',
  'acta_matrimonio',
] as const;

export const TIPOS_DOC_GLOBAL = [
  ...TIPOS_DOC_EJIDO,
  ...TIPOS_DOC_PRIVADO,
  'contrato_firmado',
] as const;
export type TipoDoc = (typeof TIPOS_DOC_GLOBAL)[number];

/**
 * Subtipos de irregularidades (PIPELINE.md secc. 4.5).
 * `subdivision_irregular` agregado tras detectar el caso en campo (Captura).
 */
export const SUBTIPOS_IRREGULARIDAD = [
  'sin_certificado_parcelario',
  'conflicto_limites_vecinos',
  'conflicto_familiar_sucesion',
  'posesion_sin_titulo',
  'gravamen_activo',
  'adeudo_predial',
  'documentacion_incompleta',
  'identidad_inconsistente',
  'doble_titularidad_ran',
  'subdivision_irregular',
] as const;
export type SubtipoIrregularidad = (typeof SUBTIPOS_IRREGULARIDAD)[number];

export const GRAVEDADES = ['leve', 'media', 'alta', 'bloqueante'] as const;
export type Gravedad = (typeof GRAVEDADES)[number];

export const RIESGOS = ['bajo', 'medio', 'alto'] as const;
export type Riesgo = (typeof RIESGOS)[number];
